/* eslint-disable indent */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { injectIntl, intlShape } from 'react-intl';
import { Icon } from 'semantic-ui-react';
import Table from 'semantic-table-grid';
import { RemoveBtn, EditBtn, ModalNewBtn } from '../../../Buttons';
import { WrapperTool } from '../../../Layout';
import Modal from '../../../Modal';
import CommissionContractForm from '../../DestinationCommission';
import { addNotification } from '../../../../utils/notification';
import messages from '../messages';
import percentageFormatter from '../../../../utils/percentageFormatter';
import appMessages from '../../../../containers/App/messages';
import DestinationInvoiceAmountService from '../../../../shared/services/destinationinvoiceamount';

const paginationDefault = {
  page: 1,
  page_count: 0,
  page_size: 5,
  total_items: 0,
};

function ExcludeCommissionsPart(props) {
  const [commissions, setCommissions] = useState([]);
  const [selectedCommission, setSelectedCommission] = useState(null);
  const [modalOpened, setModalOpened] = useState(false);
  const [paginationData, setPaginationData] = useState({
    ...paginationDefault,
  });
  const [loading, setLoading] = useState(true);
  const [isAmount] = useState(true);

  useEffect(
    () => {
      // eslint-disable-next-line no-unused-expressions
      props.values.id && loadData();
    },
    [props.values.id, paginationData.page],
  );

  const loadData = page => {
    setLoading(true);
    DestinationInvoiceAmountService.getOwnerExceptionCommissions(
      props.values.id,
      page || paginationData.page,
    ).then(res => {
      const data = _.get(res, 'data', { ...paginationDefault });
      setPaginationData({
        page: data.page,
        page_count: data.page_count,
        page_size: data.page_size,
        total_items: data.total_items,
      });
      setLoading(false);
      setCommissions(
        _.get(res, `data._embedded.destination-exception-commission`),
        [],
      );
    });
  };

  const closeModal = () => {
    setSelectedCommission(null);
    setModalOpened(false);
  };

  const openModal = () => {
    setSelectedCommission({});
    setModalOpened(true);
  };

  const columns = () =>
    [
      {
        key: 'startDate',
        width: '8%',
        name: props.intl.formatMessage(messages.commissionStartDate),
        formatter: ({ data }) =>
          _.get(data, 'startDate.date', null)
            ? moment(data.startDate.date).format('DD-MM-YYYY')
            : null,
      },
      {
        key: 'endDate',
        width: '8%',
        name: props.intl.formatMessage(messages.commissionEndDate),
        formatter: ({ data }) =>
          _.get(data, 'endDate.date', null)
            ? moment(data.endDate.date).format('DD-MM-YYYY')
            : null,
      },
      {
        key: 'fromPercentage',
        width: '8%',
        name: props.intl.formatMessage(messages.fromPercentage),
        formatter: ({ data }) => {
          const value = _.get(data, 'fromPercentage', 0.0) / 100 || 0.0;
          return percentageFormatter.format(value);
        },
      },
      {
        key: 'toPercentage',
        width: '8%',
        name: props.intl.formatMessage(messages.toPercentage),
        formatter: ({ data }) => {
          const value = _.get(data, 'toPercentage', 0.0) / 100 || 0.0;
          return percentageFormatter.format(value);
        },
      },
      {
        key: 'commission',
        width: '8%',
        name: props.intl.formatMessage(messages.commission),
        formatter: ({ data }) => {
          const value = _.get(data, 'commission', 0.0) / 100 || 0.0;
          return percentageFormatter.format(value);
        },
      },
      {
        key: 'flat',
        width: '8%',
        name: props.intl.formatMessage(messages.flat_unit),
        formatter: ({ data }) => {
          const value = _.get(data, 'flatUnit', 0.0) / 100 || 0.0;
          return percentageFormatter.format(value);
        },
      },
      {
        key: 'refund',
        width: '8%',
        name: props.intl.formatMessage(messages.refund),
        formatter: ({ data }) => {
          const value = _.get(data, 'refund', 0.0) / 100 || 0.0;
          return percentageFormatter.format(value);
        },
      },
      {
        key: 'product',
        name: props.intl.formatMessage(messages.product),
        formatter: ({ data }) => `${_.get(
          data,
          '_embedded.product.productCode',
          '',
        )}
        ${_.get(data, '_embedded.product.title', '')}`,
      },
      {
        key: 'includedInBonus',
        width: '8%',
        name: props.intl.formatMessage(messages.isIncludedInBonus),
        formatter: ({ data }) =>
          props.intl.formatMessage(
            messages[data.includedInBonus ? 'award_true' : 'award_false'],
          ),
      },
      !props.readOnly && {
        key: 'actions',
        name: props.intl.formatMessage(appMessages.actions),
        // eslint-disable-next-line react/prop-types
        formatter: ({ data }) => (
          <div style={{ width: 80 }}>
            <EditBtn
              action={() => {
                setSelectedCommission(data);
                setModalOpened(true);
              }}
            />
            <RemoveBtn
              action={() => {
                setLoading(true);
                DestinationInvoiceAmountService.removeException(data.id)
                  .then(() => {
                    setLoading(false);
                    loadData();
                    addNotification({
                      title: null,
                      message: props.intl.formatMessage(
                        messages.subject_removed_success,
                      ),
                      isError: false,
                    });
                  })
                  .catch(error => {
                    setLoading(false);
                    addNotification({
                      title: null,
                      message: error.data.detail,
                      isError: true,
                    });
                  });
              }}
              {...props}
            />
          </div>
        ),
        width: '80px',
      },
    ].filter(o => o);

  return (
    <div>
      <Table
        elements={commissions}
        rowClassKey="role-row-class"
        columns={columns()}
        isLoading={loading}
        canPaginate={{
          active: paginationData.total_items > 0,
          pageCount: paginationData.page_count,
          pageSize: paginationData.page_size,
          totalItems: paginationData.total_items,
          page: paginationData.page,
          onSelect: page => {
            setPaginationData({
              ...paginationData,
              page,
            });
          },
        }}
        canAction={{
          active: !props.readOnly,
          actions: [
            <WrapperTool key="wrapper">
              <Modal
                open={modalOpened}
                onClose={() => {
                  closeModal();
                }}
                title={
                  <h2>
                    <Icon name="users" />{' '}
                    {props.intl.formatMessage(messages.add_new)}
                  </h2>
                }
                trigger={
                  <ModalNewBtn onClick={openModal}>
                    {props.intl.formatMessage(messages.add_new)}
                  </ModalNewBtn>
                }
                size="mini"
                style={{ width: 650 }}
                scrolling
              >
                <CommissionContractForm
                  entityId={props.values.id}
                  entity={props.entity}
                  contractId={props.values.id}
                  close={closeModal}
                  commissionService={DestinationInvoiceAmountService}
                  initialValues={selectedCommission}
                  isAmount={isAmount}
                  commissionType={props.commissionType}
                  update={() => loadData(1)}
                  isExclude
                />
              </Modal>
            </WrapperTool>,
          ],
        }}
        hiddenHeaderIfEmpty
        emptyResults={
          <div>{props.intl.formatMessage(appMessages.no_results)}</div>
        }
      />
    </div>
  );
}

ExcludeCommissionsPart.defaultProps = {
  values: {},
  readOnly: false,
};

ExcludeCommissionsPart.propTypes = {
  values: PropTypes.object,
  readOnly: PropTypes.bool,
  intl: intlShape.isRequired,
  commissionType: PropTypes.string,
  entity: PropTypes.string,
};

export default injectIntl(ExcludeCommissionsPart);
